import API_BASE_URL from './config';
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

function Studbook() {
  const [dogs, setDogs] = useState([]);
  const [breeds, setBreeds] = useState([]);
  const [selectedBreed, setSelectedBreed] = useState('');
  const [includeDeceased, setIncludeDeceased] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE_URL}/studbook?includeDeceased=${includeDeceased}`)
      .then(res => {
        console.log('Studbook status:', res.status);
        if (!res.ok) throw new Error(`Fetch failed: ${res.status}`);
        return res.json();
      })
      .then(data => {
        console.log('Studbook dogs:', data);
        setDogs(data);
        const uniqueBreeds = [...new Set(data.map(dog => dog.breed))].sort();
        setBreeds(uniqueBreeds);
      })
      .catch(err => console.error('Studbook error:', err.message));
  }, [includeDeceased]);

  const filteredDogs = selectedBreed
    ? dogs.filter(dog => dog.breed === selectedBreed)
    : dogs;

  return (
    <div style={{ maxWidth: '1200px', margin: '0 auto', textAlign: 'center', padding: '20px' }}>
      <h1 style={{ color: '#1E88E5', marginBottom: '20px' }}>Studbook</h1>
      <div style={{ marginBottom: '20px', display: 'flex', justifyContent: 'center', gap: '20px', alignItems: 'center' }}>
        <div>
          <label style={{ marginRight: '10px', fontWeight: 'bold', color: '#333' }}>Filter by Breed:</label>
          <select
            id="breedFilter"
            value={selectedBreed}
            onChange={(e) => setSelectedBreed(e.target.value)}
            style={{ padding: '5px', borderRadius: '5px', border: '1px solid #ccc' }}
          >
            <option value="">All Breeds</option>
            {breeds.map(breed => (
              <option key={breed} value={breed}>{breed}</option>
            ))}
          </select>
        </div>
        <label style={{ fontWeight: 'bold', color: '#333' }}>
          <input
            type="checkbox"
            checked={includeDeceased}
            onChange={(e) => setIncludeDeceased(e.target.checked)}
            style={{ marginRight: '5px' }}
          />
          Include Deceased
        </label>
      </div>
      {filteredDogs.length > 0 ? (
        <div style={{ 
          backgroundColor: '#f9f9f9', 
          padding: '20px', 
          borderRadius: '8px', 
          boxShadow: '0 2px 5px rgba(0,0,0,0.1)', 
          border: '1px solid #BBDEFB' 
        }}>
          {filteredDogs.map(dog => (
            <Link key={dog._id} to={`/dog/${dog.dogId}`} style={{ textDecoration: 'none', color: 'inherit' }}>
              <div style={{ 
                display: 'flex', 
                alignItems: 'center', 
                margin: '20px 0', 
                padding: '15px', 
                backgroundColor: '#fff', 
                borderRadius: '5px', 
                boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
                transition: 'transform 0.2s',
                cursor: 'pointer'
              }}
              onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
              onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
              >
                <img 
                  src={dog.artUrl} 
                  alt={dog.registeredName} 
                  style={{ width: '100px', height: '100px', marginRight: '20px', objectFit: 'contain', borderRadius: '5px' }} 
                  onError={(e) => e.target.src = 'https://via.placeholder.com/100?text=No+Image'}
                />
                <div style={{ textAlign: 'left' }}>
                  <strong style={{ color: '#1E88E5', fontSize: '1.2em' }}>{dog.registeredName}</strong> 
                  <span style={{ color: '#555' }}> ({dog.breed})</span>
                  <br />
                  <span style={{ color: '#333' }}>ID: {dog.dogId || 'N/A'} | Owner: {dog.playerId?.username || 'Unknown'}</span>
                  <br />
                  <span style={{ color: dog.status === 'Deceased' ? '#ff4d4d' : '#1976D2' }}>Status: {dog.status}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      ) : (
        <p style={{ color: '#888', fontSize: '16px' }}>No dogs in studbook yet.</p>
      )}
    </div>
  );
}

export default Studbook;